export default __webpack_public_path__ + "static/media/flag-vi.0b3a5c5f.svg";